import { FC } from 'react';
import css from './styles.module.scss';

interface SubtitleProps {
  icon: JSX.Element;
  text: string;
}

const Subtitle: FC<SubtitleProps> = ({ text, icon }: SubtitleProps) => {
  return (
    <div className={css.subtitle}>
      <div className={css.subtitleIcon}>{icon}</div>
      {text}
    </div>
  );
};

export default Subtitle;
